import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate
} from "react-router-dom";

import { useEffect, useState } from "react";
import axios from "axios";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CreateProperty from "./pages/CreateProperty";
import PropertyPage from "./pages/PropertyPage";
import SoldProperties from "./pages/SoldProperties";
import Profile from "./pages/Profile";
import Sidebar from "./components/Sidebar";

function Layout() {
  const location = useLocation();

  const isLogin =
    location.pathname === "/";

  return (
    <div style={styles.container}>
      {!isLogin && <Sidebar />}

      <main
        style={
          isLogin
            ? styles.loginContent
            : styles.pageContent
        }
      >
        <Routes>
          <Route
            path="/"
            element={<Login />}
          />

          <Route
            path="/dashboard"
            element={<Dashboard />}
          />

          <Route
            path="/criar-imovel"
            element={<ProtectedCreateProperty />}
          />

          <Route
            path="/imovel/:id"
            element={<PropertyPage />}
          />

          <Route
            path="/imoveis-vendidos"
            element={<SoldProperties />}
          />

          <Route
            path="/perfil"
            element={<Profile />}
          />
        </Routes>
      </main>
    </div>
  );
}

function ProtectedCreateProperty() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    verificarPermissao();
  }, []);

  const verificarPermissao = async () => {
    try {
      const res = await axios.get(
        "/properties/permissions/create",
        {
          withCredentials: true
        }
      );

      setAllowed(res.data.canCreateProperty === true);
    } catch {
      setAllowed(false);
    }

    setLoading(false);
  };

  if (loading) {
    return (
      <div style={protectedStyles.page}>
        <p style={protectedStyles.text}>
          Verificando permissão...
        </p>
      </div>
    );
  }

  if (!allowed) {
    return (
      <div style={protectedStyles.page}>
        <div style={protectedStyles.card}>
          <h1 style={protectedStyles.title}>
            Acesso negado
          </h1>

          <p style={protectedStyles.text}>
            Você não tem permissão para acessar a página de criação de imóveis.
          </p>

          <button
            onClick={() => navigate("/dashboard")}
            style={protectedStyles.button}
          >
            Voltar para dashboard
          </button>
        </div>
      </div>
    );
  }

  return <CreateProperty />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

const styles = {
  container: {
    display: "flex",
    width: "100%",
    minHeight: "100vh",
    background: "#0f172a"
  },

  loginContent: {
    flex: 1,
    minHeight: "100vh"
  },

  pageContent: {
    flex: 1,
    minWidth: 0,
    minHeight: "100vh",
    overflow: "auto"
  }
};

const protectedStyles = {
  page: {
    width: "100%",
    minHeight: "100vh",
    background: "#0f172a",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    boxSizing: "border-box",
    color: "#fff"
  },

  card: {
    width: "100%",
    maxWidth: 430,
    background: "rgba(15,23,42,0.96)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 22,
    padding: 26,
    textAlign: "center",
    boxSizing: "border-box"
  },

  title: {
    margin: 0,
    color: "#f8fafc",
    fontSize: 26
  },

  text: {
    color: "#94a3b8",
    lineHeight: 1.5
  },

  button: {
    marginTop: 14,
    padding: "12px 16px",
    borderRadius: 12,
    border: "none",
    background: "#2563eb",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer"
  }
};